import { OnInit, Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { loadLocal } from '../../helpers/helpers';
import { tableFilterTypes } from 'src/app/store/performers.era';
import { sponsorColumnsById } from 'src/app/helpers/table-helpers';
import { JoiEvent, Label, LabelObject } from 'globals/store/events.data';
import { SponsorsTableData, sponsorColumns } from 'src/app/helpers/table-column-types';
import { TableColumn, TableMenuItem } from 'src/app/helpers/table.data';
import { sponsorColumnsReselector } from 'src/app/store/reselectors/performers.reselector';
import { addASponsor, importTableData, saveTable } from '../performers/performerSharedFunctions';
import { sponsorsTableReselector } from 'src/app/store/reselectors/sponsors.reselector';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { ManageSponsorData, ManageSponsorComponent } from '../manage/manage-sponsor.component';
import { NestedTableComponent } from 'src/app/components/nested-table/nested-table.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Sponsor } from 'globals/store/sponsors.data';
import { LabelUpdateFunctionParams } from '../../components/label-marker/label-maker.dialog.component';
import { addLabelsToMany, removeLabelsFromMany } from '../../helpers/label-helpers';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { listDifference, listUnion } from 'globals/helpers/helpers';
import { DatePipe } from '@angular/common';
@Component({
    selector: 'sponsors-table',
    template: `
<top-menu></top-menu>
<mobile-menu></mobile-menu>
<command-menu
  [filterPage]="filterPage"
  [filterType]="filterType"
  [filterText]="'Filter sponsors'"
  [showDottedMenu]="true"
  [showExport]="true"
  [showImport]="true"
  [canEditColumns]="true"
  [addItemText]="!event || event.is_readonly ? '' : '+ ADD A SPONSOR'"
  (addItem)="addASponsor($event)"
  (onExport)="saveTable()"
  (onImport)="importTableData()"
></command-menu>
<nested-table
  [items]="tableData"
  [filtersId]="filterPage"
  [condensedView]="condensed"
  [columns]="columnData"
  [columnsById]="columnsById"
  [menuItems]="menuItems"
  [menuDisabled]="busy"
  [defaultSelectedColumnId]="sponsorColumns.name"
  [readOnly]="event?.is_readonly"
  [emptyMessage]="'No sponsors in this event'"
  (selectItem)="manageSponsor($event)"
  (updatedSelectedIds)="selectIds($event)"
></nested-table>
<loader-pane-fragment [trace]="traceNames.viewSponsors"></loader-pane-fragment>
`,
    styleUrls: ['../../page.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [NestedTableComponent, LoaderPaneFragmentComponent, CommandMenuComponent, TopMenuComponent, MobileMenuComponent],
})
export class SponsorsTableComponent extends Wrapper<SponsorsTableComponent> implements OnInit {
  filterPage = filterPageTypes.sponsors
  filterType = tableFilterTypes.SponsorsTable // yes, this is hacky.  However, recreating it might be worse
  sponsorColumns = sponsorColumns
  traceNames = traceNames;
  columnData: TableColumn[] = []
  columnsById: { [id: string]: TableColumn } = sponsorColumnsById
  tableData: SponsorsTableData[] = []
  tableRowsById: { [id:string]: SponsorsTableData } = {}
  allMenuItems: TableMenuItem[] = [
    { title: 'Delete', method: this.deleteSponsors.bind(this) }
  ]
  menuItems: TableMenuItem[] = this.allMenuItems // default to showing all menu items
  condensed: boolean
  event: JoiEvent
  selectedIds: string[] 
  sponsor_labels: LabelObject = {}
  busy = false

  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<SponsorsTableData>
  saveTable() {
    saveTable('sponsor', `${this.event.title} sponsors table`, this.dialog, this.nestedTable)
  }
  importTableData(){
    importTableData('sponsor', this.dialog, this.sponsorService.addMultipleSponsors.bind(this.sponsorService))
  }



  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.uiService.changePageTitle("Sponsors", true)
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('events', 'labelMaps', 'sponsor_labels'), 'sponsor_labels')
    this.subCallback(this.store.select(sponsorsTableReselector), data => {
      console.log({ data })
      if (!data) {
        this.tableData = [] // for when the last is deleted
        return
      }
      const { sponsorTableData, sponsorTableRowsById } = data
      this.tableData = sponsorTableData
      this.tableRowsById = sponsorTableRowsById
    })
    this.loadCondensed()
    this.subCallback(this.store.select('filters', 'toggleFilters', this.filterPage, 'condensed'), _ => this.loadCondensed())
  }

  ngOnInit() {
    this.subProp(this.store.select(sponsorColumnsReselector), 'columnData')
  }

  selectIds(ids: Set<string>) {
    this.selectedIds = Array.from(ids)
    // console.log(this.selectedTaskIds)
    setTimeout(() => this.buildMenu(), 0)
  }

  private get selectedSponsors(): Sponsor[] {
    return (this.selectedIds || []).map(id => this.tableRowsById[id].sponsor)
  }

  buildMenu() {
    const sponsors = this.selectedSponsors
    const n = sponsors.length
    this.menuItems = []
    this.menuItems.push({ title: 'Add labels', method: this.addLabels.bind(this) })
    if (sponsors.some(s => s.labels?.length)) this.menuItems.push({ title: 'Remove labels', method: this.removeLabels.bind(this) })
    this.menuItems.push({ title: 'Delete', method: this.deleteSponsors.bind(this) })      
    // this.menuItems.push({ title: 'Add to clipboard', method: this.addToClipboard.bind(this) })  
  }

  async addToClipboard() {
    this.busy = true
    await this.sponsorService.templateSponsors(this.selectedSponsors)
    this.busy = false
    const n = this.selectedSponsors.length
    this.nestedTable.setMessage(`Templates for ${n} sponsor${n > 1 ? 's' : ''} added to the clipboard.`)
    this.nestedTable.unselectAll()
  }

  public async updateLabelTemplate(labels: Label[]) {
    labels.forEach(label => this.sponsor_labels[label.id] = label) // need to overwrite the old values here to both maintain order and propagate changes without losing filtered out template labels
    await this.eventService.updateEvent(this.eventService.eventId, { sponsor_labels: Object.values(this.sponsor_labels) })
  }

  public async addLabelsUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsChanged) this.updateLabelTemplate(labelTemplate)

    if (!labelsToggled) return
    const sponsors = this.selectedSponsors
      .filter(s => !s.labels || labels.some(label => !s.labels.includes(label)))
      .map(s => ({...s, labels: listUnion(s.labels, labels) }))
    
    await this.sponsorService.updateSponsors(sponsors)
    this.buildMenu()
  }

  public async removeLabelsUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsChanged) this.updateLabelTemplate(labelTemplate)

    if (!labelsToggled) return
    const filteredLabels = labelTemplate.map(l => l.id).filter(id => !labels.includes(id))
    if (filteredLabels.length === 0) return

    const sponsors = this.selectedSponsors
      .filter(s => s.labels && s.labels.some(label => filteredLabels.includes(label)))
      .map(s => ({...s,  labels: listDifference(s.labels, filteredLabels) }))

      await this.sponsorService.updateSponsors(sponsors)
    this.buildMenu()    
  }

  async removeLabels(_, event) { 
    removeLabelsFromMany(this.removeLabelsUpdateFunction.bind(this), this.sponsor_labels, this.dialog, 'sponsor', this.selectedSponsors, event)
  }

  async addLabels(_, event) { 
    addLabelsToMany(this.addLabelsUpdateFunction.bind(this), this.sponsor_labels, this.dialog, 'sponsor', this.selectedSponsors, event)
  }



  async deleteSponsors(toDelete: SponsorsTableData[], event) {
    const data: ConfirmDeleteData = {
      title: `Delete ${toDelete.length} sponsors`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to delete ${toDelete.length > 1 ? `all ${toDelete.length} selected sponsors` : 'the selected sponsor'}? The sponsor${toDelete.length > 1 ? 's' : ''} will also be removed from all sessions.`,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.busy = true
    await this.sponsorService.deleteSponsors(toDelete.map(r => r.sponsor))
    this.busy = false
  }

  addASponsor(event) {
    // console.log("NEW SPONSOR!")
    addASponsor(event, this.dialog, this.sponsorService, this.manageSponsor.bind(this))
  }


  async manageSponsor({ id }: SponsorsTableData) {
    this.changeDetectorRef.detach()
    const data: ManageSponsorData = { sponsorId: id, readOnly: !this.event || this.event.is_readonly }
    await openDialogGetResult(this.dialog, ManageSponsorComponent, { disableClose: true, autoFocus: false, data, panelClass:  'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  loadCondensed() {
    this.condensed = loadLocal(`${this.filterPage}:${toggleFilterTypes.condensed}`, false)
  }
}
